import { useWebsiteSettings } from 'publisher/store'
import { getWebsiteUserDomain } from 'src/publisher/store/website-settings/website-settings-selector'
import { isSystemeDomain } from 'src/shared/utils/is-systeme-domain'
import { shouldShowRegistrationButtonInWebsiteHeader } from 'src/shared/utils/website-header-utils'

export const useShouldShowRegistrationButtonInWebsiteHeader = (): boolean => {
  const websiteUserDomain = useWebsiteSettings(getWebsiteUserDomain)
  const isWhiteLabel = websiteUserDomain?.isWhiteLabel === true
  const isSystemeWebsiteDomain =
    !websiteUserDomain?.name || isSystemeDomain(websiteUserDomain.name)

  return shouldShowRegistrationButtonInWebsiteHeader(
    isWhiteLabel,
    isSystemeWebsiteDomain,
  )
}
